export default __webpack_public_path__ + "static/vos-cleve-29bee848c6d0cba9218109f3402b1353.mp4";